import type { ReactNode } from "react";
import { CalendarSidebarContextProvider } from "../views/one-one-sessions/components/layout/components/calendar-sidebar/context/CalendarSidebarContext";
import { ICDCodesListContextProvider } from "./icd-codes-list-context";
import { OrchidProContextProvider } from "./orchid-pro-context";
import { StripeModalContextProvider } from "./stripe-modal-context";

type Props = { children: NonNullable<ReactNode> };

const DoctorDashboardPageContextProvider = ({ children }: Props) => (
  <OrchidProContextProvider>
    <StripeModalContextProvider>
      <ICDCodesListContextProvider>
        <CalendarSidebarContextProvider>
          {children}
        </CalendarSidebarContextProvider>
      </ICDCodesListContextProvider>
    </StripeModalContextProvider>
  </OrchidProContextProvider>
);

export default DoctorDashboardPageContextProvider;
